// extracted by mini-css-extract-plugin
module.exports = {"card":"MeetingApprovalCard_card__4uIcO","asker":"MeetingApprovalCard_asker__A_Ake","question":"MeetingApprovalCard_question__1MWr4","settled":"MeetingApprovalCard_settled__eV669"};